<script>
  import Spinner from './Spinner.svelte';

  export let loading = false;
</script>

<style lang="scss">
  .loadingMask {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 15;
    min-height: 100px;
    // :global(svg) {

    // }
  }
</style>

{#if loading}
  <div class="loadingMask">
    <Spinner />
  </div>
{/if}